<template>
  <v-card class="chart-card rounded-lg" elevation="0" outlined>
    <div class="d-flex align-center px-4 pt-4">
      <span class="chart-title">{{ title }}</span>
      <v-tooltip v-if="tooltip" top color="#00BD73" max-width="320">
        <template v-slot:activator="{ on, attrs }">
          <v-icon size="16" class="ml-2 primary--text" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
      <v-spacer />
      <slot name="actions" />
    </div>
    <v-card-text class="pt-2">
      <div v-if="loading" class="d-flex align-center justify-center chart-loading">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <div v-else-if="empty" class="d-flex align-center justify-center chart-loading text--secondary">
        {{ emptyText || $t("noData") }}
      </div>
      <slot v-else />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ChartCard",
  props: {
    title: { type: String, default: "" },
    tooltip: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    empty: { type: Boolean, default: false },
    emptyText: { type: String, default: "" },
  },
};
</script>

<style scoped>
.chart-card {
  height: 100%;
}
.chart-title {
  font-size: 1rem;
  font-weight: 600;
}
.chart-loading {
  min-height: 300px;
}
</style>
